import { useState } from "react";
import { THEME, servicesOf } from "@/data/site";
import { SectionHead } from "./Reveal";
import { ServiceCard } from "./ServiceCard";

export const ServicesTabs = () => {
  const [dept, setDept] = useState("eye");
  return (
    <section id="services" data-testid="services-section" className="bg-white py-20 md:py-28">
      <div className="container-x">
        <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
          <SectionHead eyebrow="हमारी सेवाएँ · Our Services" title="जाँच से ऑपरेशन तक — हर ज़रूरत का इलाज" />
          <div className="flex rounded-full border border-line bg-sand p-1.5" role="tablist">
            {["eye", "surgery"].map((k) => (
              <button key={k} role="tab" aria-selected={dept === k} data-testid={`services-tab-${k}`} onClick={() => setDept(k)}
                className={`rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${dept === k ? `${THEME[k].bg} text-white` : "text-ink hover:bg-white"}`}>
                {THEME[k].labelHi} <span className="font-en opacity-70">({servicesOf(k).length})</span>
              </button>
            ))}
          </div>
        </div>
        <div key={dept} className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {servicesOf(dept).map((s, i) => <ServiceCard key={s.slug} s={s} i={i} />)}
        </div>
      </div>
    </section>
  );
};
